import React, { useEffect, useState } from "react";
import axios from "axios";
import { initialTokenData } from "../../seed";
import { CiStar } from "react-icons/ci";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { PuffLoader } from "react-spinners";

const TokenList = ({ tokens, setTokens }) => {
  const [loading, setLoading] = useState(true);
  const ITEMS_PER_PAGE = 25;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(tokens.length / ITEMS_PER_PAGE);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;

  const paginatedTokens = tokens.slice(startIndex, endIndex);

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage((p) => p + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage((p) => p - 1);
  };

  useEffect(() => {
    let intervalId;

    const fetchTokens = async () => {
      try {
        const res = await axios.get(
          "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&category=real-estate",
          {
            params: {
              vs_currency: "usd",
              category: "real-estate",
              order: "market_cap_desc",
              per_page: 300,
              page: 1,
              sparkline: false,
              price_change_percentage: "1h,24h,7d",
            },
          }
        );

        setTimeout(() => setTokens(res.data), 4000);
      } catch (error) {
        console.error("Failed to fetch tokens", error);
        setTokens(initialTokenData);
      } finally {
        setLoading(false);
      }
    };
    console.log(tokens);
    // initial fetch
    fetchTokens();

    // fetch every 10 seconds
    intervalId = setInterval(fetchTokens, 10000);

    // cleanup on unmount
    return () => clearInterval(intervalId);
  }, []);

  if (loading) {
    return <div className="text-center py-10 text-gray-400">Loading...</div>;
  }

  return (
    <div className="flex flex-col transition-all duration-500 ease-in-out">
      {tokens.length ? (
        <>
          {" "}
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm text-left text-gray-500 ">
              <thead className="text-xs border border-gray-900 bg-none ">
                <tr>
                  <th className="px-4 py-3 text-xs">#</th>
                  <th className="px-4 py-3 text-xs">Name</th>
                  <th className="px-4 py-3 text-xs">Price</th>
                  <th className="px-4 py-3 text-xs hidden md:table-cell">
                    1h %
                  </th>
                  <th className="px-4 py-3 text-xs">24h %</th>
                  <th className="px-4 py-3 text-xs hidden md:table-cell">
                    7d %
                  </th>
                  <th className="px-4 py-3 text-xs hidden md:table-cell">
                    Market Cap
                  </th>
                  <th className="px-4 py-3 text-xs hidden md:table-cell">
                    Volume (24h)
                  </th>
                  <th className="px-4 py-3 text-xs hidden md:table-cell">
                    Circulating Supply
                  </th>
                </tr>
              </thead>

              <tbody>
                {paginatedTokens.map((coin, index) => (
                  <tr
                    key={coin.id}
                    className="border-b border-gray-900 hover:bg-gray-900"
                  >
                    <td className="px-4 py-3 ">
                      <span className="flex justify-start items-center">
                        <CiStar />
                        <span className="ml-4">{index + 1}</span>
                      </span>
                    </td>

                    <td className="px-4 py-3 flex items-center gap-2">
                      <div className="flex justify-between items-center w-40">
                        <div className="flex flex-col ">
                          <div className="flex justify-start items-center">
                            {" "}
                            <img
                              src={coin.image}
                              alt={coin.name}
                              className="w-5 h-5 rounded-full"
                            />
                            <div className="flex pl-1  flex-col justify-start items-start">
                              {" "}
                              <span
                                style={{ fontSize: "10px" }}
                                className="font-medium text-xs"
                              >
                                {coin.name}
                              </span>
                              <span
                                style={{ fontSize: "8px" }}
                                className="uppercase  text-xs text-gray-500"
                              >
                                {coin.symbol}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="h-6 w-12 flex justify-center items-center border-2 border-yellow-800 rounded-lg">
                          <a
                            href="https://tokens.pittsburghprivateadvisors.com/user/login"
                            style={{ fontSize: "11px" }}
                            className="h-6 flex justify-center items-center w-12 text-yellow-800 font-semibold  text-xs outline-none focus:outline-none"
                          >
                            Buy
                          </a>
                        </div>
                      </div>
                    </td>

                    <td
                      style={{ fontSize: "12px" }}
                      className="px-4 py-3 font-bold"
                    >
                      ${coin.current_price.toFixed(4).toLocaleString()}
                    </td>

                    <td
                      style={{ fontSize: "12px" }}
                      className={`px-4 py-3 font-bold hidden md:table-cell ${
                        coin?.price_change_percentage_1h_in_currency < 0
                          ? "text-red-500"
                          : "text-green-500"
                      }`}
                    >
                      {coin?.price_change_percentage_1h_in_currency !== null &&
                      coin?.price_change_percentage_1h_in_currency !==
                        undefined ? (
                        <div className="flex justify-start items-center">
                          <div>
                            {coin?.price_change_percentage_1h_in_currency <
                            0 ? (
                              <IoMdArrowDropdown className="text-xl" />
                            ) : (
                              <IoMdArrowDropup className="text-xl" />
                            )}
                          </div>
                          <span>
                            {`${Math.abs(
                              coin.price_change_percentage_1h_in_currency
                            ).toFixed(2)}%`}
                          </span>
                        </div>
                      ) : (
                        <span className="w-full flex justify-center items-center">
                          --
                        </span>
                      )}
                    </td>

                    <td
                      style={{ fontSize: "12px" }}
                      className={`px-4 py-3 ${
                        coin.price_change_percentage_24h < 0
                          ? "text-red-500"
                          : "text-green-500"
                      }`}
                    >
                      {coin?.price_change_percentage_24h !== null &&
                      coin?.price_change_percentage_24h !== undefined ? (
                        <div className="flex justify-start items-center font-bold">
                          <div>
                            {coin?.price_change_percentage_24h < 0 ? (
                              <IoMdArrowDropdown className="text-xl" />
                            ) : (
                              <IoMdArrowDropup className="text-xl" />
                            )}
                          </div>
                          <span>
                            {`${Math.abs(
                              coin.price_change_percentage_24h
                            ).toFixed(2)}%`}
                          </span>
                        </div>
                      ) : (
                        <span className="w-full flex justify-center items-center">
                          --
                        </span>
                      )}
                    </td>

                    <td
                      style={{ fontSize: "12px" }}
                      className={`px-4 py-3 font-bold hidden md:table-cell ${
                        coin.price_change_percentage_7d_in_currency < 0
                          ? "text-red-500"
                          : "text-green-500"
                      }`}
                    >
                      {coin?.price_change_percentage_7d_in_currency !== null &&
                      coin?.price_change_percentage_7d_in_currency !==
                        undefined ? (
                        <div className="flex justify-start items-center">
                          <div>
                            {coin?.price_change_percentage_7d_in_currency <
                            0 ? (
                              <IoMdArrowDropdown className="text-xl" />
                            ) : (
                              <IoMdArrowDropup className="text-xl" />
                            )}
                          </div>
                          <span>
                            {" "}
                            {`${Math.abs(
                              coin.price_change_percentage_7d_in_currency
                            ).toFixed(2)}%`}
                          </span>
                        </div>
                      ) : (
                        <span className="w-full flex justify-center items-center">
                          --
                        </span>
                      )}
                    </td>

                    <td
                      style={{ fontSize: "12px" }}
                      className="px-4 py-3 font-bold hidden md:table-cell"
                    >
                      ${coin.market_cap.toLocaleString()}
                    </td>

                    <td
                      style={{ fontSize: "12px" }}
                      className="px-4 py-3 font-bold hidden md:table-cell"
                    >
                      ${coin.total_volume.toLocaleString()}
                    </td>

                    <td
                      style={{ fontSize: "12px" }}
                      className="px-4 py-3 font-bold hidden md:table-cell"
                    >
                      {coin.circulating_supply.toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex justify-between px-4 my-6 addPaginationhere">
            <div
              style={{ fontSize: "9px" }}
              className="flex justify-start items-center"
            >
              <span className="pl-1 text-gray-500 font-semibold">Showing</span>
              <span className="pl-1 text-gray-500 font-semibold">
                {startIndex + 1}
              </span>
              <span className="pl-1 text-gray-500 font-semibold">-</span>
              <span className="pl-1 text-gray-500 font-semibold">
                {Math.min(endIndex, tokens.length)}
              </span>
              <span className="pl-1 text-gray-500 font-semibold">out of</span>
              <span className="pl-1 text-gray-500 font-semibold">
                {tokens.length}
              </span>
            </div>

            <div className="flex items-center gap-2">
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                (page) => (
                  <span
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={`px-3 py-1 outline-none focus:outline-none border rounded text-xs ${
                      page === currentPage
                        ? "bg-blue-500 text-white border-blue-500"
                        : "text-gray-600 border-gray-900"
                    }`}
                  >
                    {page}
                  </span>
                )
              )}
            </div>
          </div>
        </>
      ) : (
        <div className="flex justify-center items-center my-40">
          <PuffLoader color="#debd16" size={100} />
        </div>
      )}
    </div>
  );
};

export default TokenList;
